import { QuickActionType } from '@compiere-ws/models/apiz-domains';

export type QuickActionData = {
  type?: QuickActionType;
  label: string;
  action?: (target: QuickActionData | QuickActionSubData) => void;
  subActions?: QuickActionSubData[];
  subActionsDataQuery?: {
    columnName: string;
    context?: { [key: string]: unknown };
  };
  processId?: number;
  readonly?: boolean;
};

export type QuickActionSubData = {
  id: string | number;
  displayValue: string;
};

export const QuickActionTypeIconMapping = {
  NEWRECORD: 'icon-add-square',
  PROCESS: 'fa-solid fa-gear',
} as const;
